import { Checkbox, Label } from "flowbite-react";
import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

type Props = {
  optOut: boolean
  onOptOutChange: (value: boolean) => void
  disabled?: boolean
};

const OPT_OUT_CHECKBOX_ID = "pronostics-onboarding-opt-out";

export const GoodLuckStep = ({ optOut, onOptOutChange, disabled = false }: Props) => {
  return (
    <div className="space-y-5 text-center">
      <div className="space-y-3">
        <H2>Que le meilleur gagne !</H2>
        <P color="muted" size="sm" className="mx-auto max-w-md">
          Tu es prêt ! Fais tes pronostics, vibre à chaque match, et bonne chance pour ce tournoi !
        </P>
      </div>

      <div className="rounded-lg bg-gray-50 px-4 py-3 text-left dark:bg-gray-800/60">
        <div className="flex items-start gap-3">
          <Checkbox
            id={OPT_OUT_CHECKBOX_ID}
            checked={optOut}
            onChange={(event) => onOptOutChange(event.target.checked)}
            disabled={disabled}
            className="mt-0.5"
          />
          <div className="min-w-0">
            <Label
              htmlFor={OPT_OUT_CHECKBOX_ID}
              className="text-sm font-medium text-gray-900 dark:text-white"
            >
              Je ne souhaite pas participer à la compétition
            </Label>
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Tu pourras changer d&apos;avis à tout moment depuis les paramètres.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

GoodLuckStep.displayName = "GoodLuckStep";
